import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import './index.css';

// Принудительно отключаем Service Worker и чистим кэши, чтобы избежать показа старого бандла
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
            registrations.forEach((registration) => registration.unregister());
        })
        .catch(() => {});

    if ((window as any).caches) {
        (window as any).caches
            .keys()
            .then((keys: string[]) => {
                keys.forEach((key) => (window as any).caches.delete(key));
            })
            .catch(() => {});
    }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    //<React.StrictMode>
    <App />
    // </React.StrictMode>
);
